var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinishedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 29,
    viewBox: "0 0 42 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9374 10.7944C32.7698 4.76014 27.5671 0.230103 21.3169 0.230103C16.3545 0.230103 12.0447 3.09854 9.8983 7.29626C4.72989 7.85595 0.711914 12.316 0.711914 17.7206C0.711914 23.5099 5.33086 28.2149 11.0144 28.2149H33.3365C38.0756 28.2149 41.9219 24.297 41.9219 19.4696C41.9219 14.8521 38.4019 11.1092 33.9374 10.7944ZM17.8827 22.9677L11.8729 16.8461L14.294 14.3799L17.8827 18.0179L26.7772 8.97534L29.1983 11.4415L17.8827 22.9677Z",
    fill: "#F39C12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedicon);
export default __webpack_public_path__ + "static/media/finishedicon.cd517fca0d7008981d1e90c51e91333c.svg";
export { ForwardRef as ReactComponent };